import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Urls } from "../../../utils/constant";

import { useApi } from "../apiCall/useApi";

import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";

import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";

import {
  setDoctorHolidayList,
  setDoctorComboList,
  setLeaveComboList,
} from "../../reducers/DoctorHoliday/doctorHoliday.reducer";
import {
  getDoctorList,
  getLeaveList,
} from "../../selectors/DoctorHoliday/doctorHoliday.selector";

const COLUMN_LIST = [
  {
    field: "sr_no",
    headerName: "sr. no.",
    flex: 1,
  },
  {
    field: "doctor_name",
    headerName: "Doctor Name",

    flex: 2,
  },
  {
    field: "from_date_formate",
    headerName: "Holiday Date",
    flex: 2,
  },
  {
    field: "leave_type",
    headerName: "Leave Type",

    flex: 2,
  },
  {
    field: "status_val",
    headerName: "Status",
    flex: 1,
  },
];

const StatusList = [
  { id: 1, label: "active" },
  { id: 2, label: "In-Active" },
];

export default function useDoctorHoliday() {
  const dispatch = useDispatch();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [DoctorId, setDoctorId] = useState("");
  const [LeaveId, setLeaveId] = useState("");
  const [status, setStatus] = useState(1);
  const doctorList = useSelector(getDoctorList);
  const leaveList = useSelector(getLeaveList);

  const fetchDoctorHoliday = useCallback(
    async ({ current_page = 1, row_count }) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        const StatusVal = status === "All" ? 0 : status;
        const { data } = await apiPost({
          url: Urls.doctorHolidayGet(),
          data: {
            doctor_id: DoctorId,
            status: StatusVal,
            page_size: row_count,
            current_page: current_page,
          },
        });
        // setting list to reducer

        dispatch(setDoctorHolidayList(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
      }
    },
    [loading, DoctorId, status]
  );

  const fetchDoctorComboList = useCallback(async () => {
    try {
      const { data } = await apiPost({
        url: Urls.getDoctorCombo(),
        data: {},
      });
      // setting list to reducer

      dispatch(setDoctorComboList(data.data));
    } catch (err) {
      console.log(err);
    }
  }, [DoctorId]);

  const fetchLeaveComboList = useCallback(async () => {
    try {
      const { data } = await apiPost({
        url: Urls.getLeaveCombo(),
        data: {},
      });
      // setting list to reducer

      dispatch(setLeaveComboList(data));
    } catch (err) {
      console.log(err);
    }
  }, [LeaveId]);

  const findDoctorFromLabel = useCallback(
    (value) => {
      const selectedDoctorId = value
        ? doctorList.find((item) => item.label === value)?.id
        : null;
      setDoctorId(selectedDoctorId);
      return selectedDoctorId;
    },
    [doctorList]
  );
  const findLeaveFromLabel = useCallback(
    (value) => {
      const selectedLeaveId = value
        ? leaveList.find((item) => item.label === value)?.id
        : null;
      setLeaveId(selectedLeaveId);
      return selectedLeaveId;
    },
    [leaveList]
  );

  const handleStatusChange = useCallback((e) => {
    setStatus(e.target.value);
  }, []);

  return {
    gridHeaders: COLUMN_LIST,
    loading,
    loader,
    DoctorId,
    LeaveId,
    status,
    StatusList,
    findDoctorFromLabel,
    handleStatusChange,
    fetchDoctorHoliday,
    fetchDoctorComboList,
    fetchLeaveComboList,
    findLeaveFromLabel,
  };
}
